'use client';

import { flex, vstack } from '@onbeam/business-styled-system/patterns';
import { Link } from '@onbeam/business-ui';
import { FormReviewGroupProps } from './FormReviewGroup.types';
import { useFormContext } from '../FormContext';

export const FormReviewGroup = ({
  title,
  stepIndex,
  children,
}: FormReviewGroupProps) => {
  const { onNavigate } = useFormContext();

  const handleEdit = () => {
    onNavigate(stepIndex);
  };

  return (
    <div className={vstack({ gap: '5' })}>
      <div className={flex({ justify: 'space-between', gap: '2' })}>
        <h2>{title}</h2>
        <Link as="button" type="button" onClick={handleEdit}>
          Edit
        </Link>
      </div>
      {children}
    </div>
  );
};
